import classNames from 'classnames'
import { ReactElement } from 'react'

export function CountBadge({
  value,
  className,
  isActive,
}: {
  value: number
  className?: string
  isActive?: boolean
}): ReactElement | null {
  if (value <= 0) return null

  return (
    <div
      className={classNames(
        `flex max-h-5 shrink-0 items-center justify-center rounded px-1.5 py-0.5`,
        isActive ? `bg-primary-600` : `bg-primary-100`,
        className,
      )}
    >
      <span className={classNames(`text-label-xs font-semibold`, isActive ? `text-on-color` : `text-primary-700`)}>
        {value < 100 ? value : `99+`}
      </span>
    </div>
  )
}
